module.exports = __webpack_public_path__ + "img/belt-3.a1512863.png";